// extracted by mini-css-extract-plugin
export default {"boxContainer":"Home_boxContainer__VjA4s","sec":"Home_sec__szCHC"};